export enum WalletType {
  ICON,
  LEDGER,
}
